<template>
  <component
    class="tgbButton icon"
    :type="type"
    :is="btnType"
    :href="href"
    :to="to"
    :class="variantType"
    @click="click">
     <span :class="iconType"></span>
    <span><slot></slot></span>
  </component>
</template>

<script>
export default {
  emits: ['click'],
  name: 'TgbButton',
  methods: {
    click() {
      this.$emit('click');
    },
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'button',
      // validator: //Write a function here to validate the types.
    },
    href: {
      type: String,
    },
    to: {},
    icon: {
      type: String,
    }
  },
  computed: {
    variantType() {
      return `tgbButton--${this.variant}`;
    },
    iconType() {
      return 'fas fa-'+ this.icon;
    },
    btnType() {
      if (this.href) {
        return 'a';
      }
      if (this.to) {
        return 'router-link';
      }
      return 'button';
    },
  },
};
</script>

<style lang="scss">
  .tgbButton {
    font-weight: 600;
    min-width: auto;
    font-family: inherit;
    font-style: normal;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
  }
  .tgbButton--primary {
    color: #fff;
    border: #007F9D;
    border-radius: 6px;
    background-color: #007F9D;

    &:hover {
      background: #109BB8;
      border-color: #109BB8;
    }

    &:active {
      background: #2BACCA;
      border-color: #2BACCA;
    }

    &:disabled {
      color: #333333;
      border-color: #6D7D85;
      background-color: #6D7D85;
    }
  }
  .tgbButton--secondary {
    background: #FFFFFF;
    border: 1px solid #2288A0;
    color: #2288A0;
    border-radius: 6px;
    padding: 6px 10px;
    gap: 6px;
    margin: 10px;

    &:hover {
      background: #FFFFFF;
      border-color: #109BB8;
    }

    &:active {
      background: #FFFFFF;
      border-color: #2BACCA;
    }

    &:disabled {
      color: #333333;
      border-color: #6D7D85;
      background-color: #6D7D85;
    }
  }
  .tgbButton--tertiary {
    color: #FFFFFF;
    background: 0 0;
    border: 0;

    &:hover {
      color: #95EBFF;
    }
    &:active {
      color: #B2F1FF;
    }
    &:disabled {
      color: #808689;
    }
  }
  .tgbButton--primaryDanger {
    color: #FFFFFF;
    background: #B22000;
    border: #B22000;
    border-radius: 6px;

    &:hover {
      background: #A70A00;
      border: #A70A00;
    }
    &:active {
      background: #901A1A;
      border: #901A1A;
    }
  }
  .tgbButton--secondaryDanger {
    color: #FFFFFF;
    border: 1px solid;
    border-color: #FFFFFF;
    border-radius: 6px;
    background-color: #1B2224;

    &:hover {
      border-color: #FF766D;
    }
    &:active {
      background: #901A1A;
      border-color: #901A1A;
    }
  }

  .tgbButton--disabled {
    cursor: not-allowed;
    border: 1px solid;
    border-radius: 6px;
    padding: 6px 10px;
    gap: 6px;
    margin: 10px;
    background-color: #F5F5F5;
    border-color: #CBCBCB;
    color: #808689;
  }

  .tgbButton--hidden {
    visibility: hidden;
  }

</style>
